export class Location {
  constructor(data) {
    var self = this;
    self.type = "Location";

    self.country = ko.observable(data.country);
    self.country_abr = ko.observable(data.country_abr);

    self.region = ko.observable(data.region);
    self.latitude = ko.observable(data.latitude);
    self.longitude = ko.observable(data.longitude);
    self.location_name = ko.observable(data.location_name);
    self.location_uuid = ko.observable(data.location_uuid);

    self.google_maps_mapping = {
      administrative_area_level_1: self.region,
      country: self.country,
    };

    self.google_maps_components = {
      administrative_area_level_1: "long_name",
      country: "short_name",
    };

    self.pretty_location_name = ko.pureComputed(function () {
      if (self.country_abr()) {
        return self.location_name() + " " + self.country_abr().toUpperCase();
      } else {
        return self.location_name();
      }
    });
  }
}
